var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCHomeIntroduceItemIcon23(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 103 92.05",
    clipRule: "evenodd",
    className: "design-iconfont",
    width: 128,
    height: 114.39223680218447,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e5ee",
    d: "M35.43 3.29H67.57V71.71000000000001H35.43z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.86 68.41l25.57 0 0 -39.67 -25.57 0 0 39.67zm-32.14 0l25.57 0 0 -42.96 0 -18.88 -25.57 0 0 34.02 0 27.82zm28.85 6.57l-32.14 0 -32.14 0c-1.82,0 -3.29,-1.47 -3.29,-3.29l0 -31.11c0,-1.82 1.47,-3.29 3.29,-3.29l28.85 0 0 -34.02c0,-1.82 1.47,-3.29 3.29,-3.29l32.14 0c1.82,0 3.29,1.47 3.29,3.29l0 18.88 28.85 0c1.82,0 3.29,1.47 3.29,3.29l0 46.25c0,1.82 -1.47,3.29 -3.29,3.29l-32.14 0zm-60.99 -6.57l25.57 0 0 -24.53 -25.57 0 0 24.53z",
    fill: "#7a808f",
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.29 92.05c-1.82,0 -3.29,-1.47 -3.29,-3.29 0,-1.82 1.47,-3.29 3.29,-3.29l96.42 0c1.82,0 3.29,1.47 3.29,3.29 0,1.82 -1.47,3.29 -3.29,3.29l-96.42 0z",
    fill: "#7a808f",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCHomeIntroduceItemIcon23);
export default __webpack_public_path__ + "static/media/c-home-introduce-item-icon-2-3.2f2bf1fa.svg";
export { ForwardRef as ReactComponent };